import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const RadioGroup = ({ name, options, defaultValue, onChange, onBlur, className }, ref) => {
    const classes = `radio-group ${className}`;

    const [selectedValue, setSelectedValue] = useState(defaultValue);

    const handleChange = (e) => onChange && onChange(e, { name: e.target.name, value: e.target.value });

    const handleBlur = (e) => onBlur && onBlur({ e, name: e.target.value, targetName: name });

    useEffect(() => {
        setSelectedValue(defaultValue);
    }, [defaultValue]);

    return (
        <div className={classes} ref={ref}>
            {options.map((opt) => {
                let imageUrl = "";

                imageUrl = selectedValue === opt.value ? opt.active_url : opt.url;

                return (
                    <div key={opt.id} className={`input__group ${selectedValue === opt.value ? "is-active" : ""}`}>
                        <input
                            type="radio"
                            id={opt.id}
                            name={name}
                            checked={selectedValue === opt.value}
                            value={opt.value}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <label htmlFor={opt.id}>
                            {imageUrl !== "" ? <img src={imageUrl} alt={opt.label} /> : ""}
                            {opt.label}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

RadioGroup.propTypes = {
    /* Built-in properties */
    defaultValue: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
};

export default React.forwardRef((props, ref) => RadioGroup(props, ref));
